import { activeSubjectExpiredAtom } from '@atom/activeSubjectStore';
import { useConsultWithEC } from '@hooks/student.hook';
import { CDN_URL } from '@utils/constants/url.constants';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import { Button, PopUp } from 'geniebook-ui/dist';
import { useAtom } from 'jotai';
import Cookies from 'js-cookie';
import moment from 'moment';
import React from 'react';
import { useParams } from 'react-router-dom';
import './WorksheetPopupCard.css';
import { IExpSubsPopUp } from '@models/interfaces/local_storage.interface';

const WorksheetPopupCard = () => {
  const params = useParams();

  const [activeSubjectExpired] = useAtom(activeSubjectExpiredAtom);

  const queryConsultWithEC = useConsultWithEC();
  const consultWithEC = () => {
    queryConsultWithEC.mutate({
      subject_id: subjectIdFromName(params.subjectId ?? ''),
    });
  };

  const defaultPopupProps = {
    img: '',
    title: '',
    description: <></>,
    buttonGroup: <></>,
  };
  const [popupProps, setPopupProps] = React.useState(defaultPopupProps);

  React.useEffect(() => {
    if (!params.subjectId) return;

    // subscription related process
    const btnPrimaryAttr = { className: 'w-full max-w-full' };
    const btnSecondaryAttr = {
      className: 'cursor-pointer font-black mt-6 text-primary-apricot',
    };

    const expiryDateMoment = moment(
      JSON.parse(localStorage.getItem('exp_subs_date') ?? '{}')[
        params.subjectId
      ],
    );
    const expiryDate = expiryDateMoment.valueOf();

    const tmpLocalStorageExpSubsPopups: IExpSubsPopUp = JSON.parse(
      localStorage.getItem('exp_subs_popup') ?? '{}',
    );

    if (
      expiryDate < moment().valueOf() &&
      expiryDate > moment(Cookies.get('user_last_login') ?? '').valueOf() &&
      (tmpLocalStorageExpSubsPopups[params.subjectId] ?? 0) != 1
    ) {
      if (
        !JSON.parse(localStorage.getItem('trial_subs') ?? '{}')[
          params.subjectId
        ]
      )
        setPopupProps({
          ...popupProps,
          img: CDN_URL + 'assets/images/Illust_End trial.svg',
          title: 'Subscription has ended',
          description: (
            <>
              {'Contact support to reactivate '}
              <div className="inline-block">your subscription.</div>
            </>
          ),
          buttonGroup: (
            <>
              <Button
                {...btnPrimaryAttr}
                onClick={() => {
                  setPopupProps(defaultPopupProps);
                }}
              >
                Got it
              </Button>
              <div
                {...btnSecondaryAttr}
                onClick={() => {
                  consultWithEC();
                  setPopupProps(defaultPopupProps);
                }}
              >
                Contact us
              </div>
            </>
          ),
        });
      tmpLocalStorageExpSubsPopups[params.subjectId] = 1;
      localStorage.setItem(
        'exp_subs_popup',
        JSON.stringify(tmpLocalStorageExpSubsPopups),
      );
    }
  }, [activeSubjectExpired, params.subjectId]); // update query params on getting subject ID / expired subscription update

  return (
    <>
      {popupProps.title && (
        <div className="container_popup_worksheet_dashboard">
          <PopUp
            {...popupProps}
            onClose={() => {
              setPopupProps(defaultPopupProps);
            }}
            // width={ (368 > width / 12 * 11 ? undefined : '368px') }
          />
        </div>
      )}
    </>
  );
};

export default WorksheetPopupCard;
